import script from "./StoryLaneOnboarding.vue?vue&type=script&setup=true&lang=js"
export * from "./StoryLaneOnboarding.vue?vue&type=script&setup=true&lang=js"

import "./StoryLaneOnboarding.vue?vue&type=style&index=0&id=268c4194&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-268c4194"]])

export default __exports__